import polishLang from 'element-ui/lib/locale/lang/pl'
const messages = Object.assign(polishLang, {
  el: {
    datepicker: {
      now: 'Teraz',
      today: 'Dzisiaj',
      cancel: 'Anuluj',
      clear: 'Wyczyść',
      confirm: 'OK',
      selectDate: 'Wybierz Datę',
      selectTime: 'Wybierz Godzinę',
      startDate: 'Data Początkowa',
      startTime: 'Godzina Początkowa',
      endDate: 'Data Końcowa',
      endTime: 'Czas Końcowa',
      prevYear: 'Poprzedni Rok',
      nextYear: 'Następny Rok',
      prevMonth: 'Poprzedni Miesiąc',
      nextMonth: 'Następny Miesiąc',
      year: '',
      month1: 'styczeń',
      month2: 'luty',
      month3: 'marzec',
      month4: 'kwiecień',
      month5: 'maj',
      month6: 'czerwiec',
      month7: 'lipiec',
      month8: 'sierpień',
      month9: 'wrzesień',
      month10: 'październik',
      month11: 'listopad',
      month12: 'grudzień',
      week: 'tydzień',
      weeks: {
        sun: 'niedz.',
        mon: 'pon.',
        tue: 'wt.',
        wed: 'śr.',
        thu: 'czw.',
        fri: 'pt.',
        sat: 'sob.'
      },
      months: {
        jan: 'STY',
        feb: 'LUT',
        mar: 'MAR',
        apr: 'KWI',
        may: 'MAJ',
        jun: 'CZE',
        jul: 'LIP',
        aug: 'SIE',
        sep: 'WRZ',
        oct: 'PAŹ',
        nov: 'LIS',
        dec: 'GRU'
      }
    }
  },
  "banner1": "Marka Solplanet należy do spółki AISWEI",
  "banner2": "dawniej SMA China",
  "banner3": "Energia słoneczna dla każdego",
  "english": "Angielski",
  "polish": "Polski",
  "spanish": "Hiszpański",
  "turkish": "Turecki",
  "germany": "Niemiecki",
  "french": "Francuski",
  "italian": "Włoski",
  "systemData1": "system",
  "installationLocation1": "montaż",
  "customerData1": "klient",
  "claimData": "Reklamacja",
  "shippingAddress1": "wysyłka",
  "customerData": "Dane klienta",
  "customerType": "Typ klienta",
  "selectCustomer": "Wybierz typ klienta",
  "--None--": "--Brak--",
  "Installer": "Instalator",
  "End-customer": "Klient końcowy",
  "Distributor": "Dystrybutor",
  "EPC": "EPC",
  "Other": "Inne",
  "companyName": "Nazwa firmy",
  "typeCompanyName": "Wprowadź nazwę firmy",
  "contacts": "Nazwisko os. kontaktowej",
  "typeContacts": "Wprowadź nazwisko os. kontaktowej",
  "contactInformation": "Nr telefonu",
  "typeContactInformation": "Wprowadź numer telefonu",
  "shippingAddress": "Adres wysyłki (w przypadku wymiany będzie to adres wysyłki).",
  "country": "Panstwo/Region",
  "typeCountry": "Wprowadi nazwe panstwa/region",
  "province": "Województwo",
  "typeProvince": "Wprowadź nazwę województwa",
  "city": "Miasto",
  "typeCity": "Wprowadź nazwę miasta",
  "area": "Ulica",
  "typeArea": "Wprowadź nazwę ulicy",
  "contacts01": "Telefon komórkowy",
  "typeContacts01": "Wprowadź numer telefonu komórkowego",
  "postCode": "Kod pocztowy",
  "typePostCode": "Wprowadź kod pocztowy",
  "email": "E-mail",
  "typeEmail": "Wprowadź adres e-mail",
  "errorEmail": "Proszę wprowadzić poprawny adres email.",
  "installationLocation": "Miejsce instalacji (użyj adresu wysyłki",
  "purchaseDate": "Dat zakupu",
  "typePurchaseDate": "Wprowadź",
  "installDate": "Data montażu",
  "typeInstallDate": "Wprowadź",
  "faultyDeviceType": "Typ usterki urządzenia",
  "selectFaultyDeviceType": "Wprowadź",
  "faultDate": "Data usterki",
  "typeFaultDate": "Wprowadź",
  "deviceSerialNumber": "Numer seryjny urządzenia",
  "typeDeviceSerialNumber": "Wprowadź",
  "faultySymptom": "Objaw usterki",
  "selectFaultySymptom": "Wprowadź",
  "errorDescription": "Szczegółowy opis błędu",
  "typeErrorDescription": "Wprowadź",
  "purchaseFileId": "Dowód zakupu (załącznik)",
  "purchaseDesc": "Dowód zakupu musi zawierać imię i nazwisko klienta, adres instalacji, model falownika oraz potwierdzenie zapłaty",
  "breakFileId": "Dowód usterki (załącznik)",
  "breakDesc": "Prosimy o przesłanie zdjęcia szczegółów usterki, komunikatu błędu oraz naklejki z numerem seryjnym produktu",
  "upload": "Wyślij",
  "systemData": "Dane systemu (opcjonalnie)",
  "systemData01": "Czy to pierwsza reklamacja dot. tej instalacji?",
  "Yes": "Tak",
  "No": "Nie",
  "Unknown": "Nie wiem",
  "systemData02": "Stan roboczy innych falowników w tej samej instalacji",
  "systemData03": "Powód wcześniejszej reklamacji",
  "enterSystemData03": "Wprowadź",
  "systemData04": "Szczegółowy opis usterki innych falowników w tej samej instalacji",
  "enterSystemData04": "Wprowadź",
  "systemData05": "Warunki, w jakich zainstalowany jest falownik",
  "systemData0501": "Wewnątrz",
  "systemData0502": "Na zewnątrz (w zacienionym miejscu budynku lub pod zadaszeniem)",
  "systemData0503": "Na zewnątrz (falownik wystawiony na bezpośrednie działanie promieni słonecznych)",
  "systemData0504": "Nad wodą",
  "systemData0505": "Inne",
  "systemData06": "Warunki w jakich zamontowane są panele słoneczne",
  "systemData0601": "Na gruncie",
  "systemData0602": "Na dachu",
  "systemData0603": "Na powierzchni wody",
  "systemData0604": "Inne ",
  "systemData07": "Marka i model paneli słonecznych",
  "typeSystemData07": "Wprowadź",
  "systemData08": "Model PV",
  "systemData0801": "Niezależne",
  "systemData0802": "Równoległe",
  "pleaseSelect": "Proszę wybrać",
  "add": "Dodaj",
  "delete": "Usunąć",
  "pv10": "string solar panel(pieces)",
  "pv101": "Szereg paneli fotowoltaicznych PV1 (szt.)",
  "pv102": "Szereg paneli fotowoltaicznych PV2 (szt.)",
  "pv103": "Szereg paneli fotowoltaicznych PV3 (szt.)",
  "pv104": "Szereg paneli fotowoltaicznych PV4 (szt.)",
  "circuit01": "Napięcie jałowe (V)",
  "alternatingVoltage": "Napięcie przemienne",
  "l1l2": "Napięcie AC L1 - L2 (V)",
  "l1n": "Napięcie AC L1 - N (V)",
  "l2l3": "Napięcie AC L2 - L3 (V)",
  "l2n": "Napięcie AC L2 - N (V)",
  "l1l3": "Napięcie AC L1 - L3 (V)",
  "l3n": "Napięcie AC L3 - N (V)",
  "l1pe": "Napięcie AC L1 - PE (V)",
  "l3pe": "Napięcie AC L3 - PE (V)",
  "l2pe": "Napięcie AC L2 - PE (V)",
  "npe": "Napięcie AC N - PE (V)",
  "complaintFileId": "Wyślij",
  "activeTip": "Uwaga: Im bardziej szczegółowe informacje dotyczące instalacji zostaną podane, tym szybciej będziemy w stanie ustalić, na czym polega problem.",
  "submitBtn": "Wyślij",
  "pleaseType": "Wprowadź",
  "submitSuccess": "Prześlij sukces",
  "submitDesc": "Niektóre wymagane pola nie są wypełniane, prosimy o ponowne przesłanie po potwierdzeniu. Dziękuję!",
  "typeUpload": "Proszę przesłać",
  "resetUpload": "Opnieuw uploaden",
  "selectErrorMessage": "Proszę wybrać",
  "errorMessage": "Inni",
  "MPPT": "MPPT",
  "chinese": "Chinese",
  "dutch": "Dutch",
  "hungary": "Hungary",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Akceptuję regulamin Solplanet",
  "iagree": "I agree with Solplanet terms & conditions",
  "language": "Język",
  "ptbr": "Portugalski (Brazylia)",
  "zhtw": "Tradycyjne chińskie",
  "documentTitle": "Gwarancji │Solplanet",
  "validateNumber": "Wprowadź liczbę całkowitą"
})
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/polish.js